export const CURRENT_VIEW_STORAGE_KEY = "currentView";
export const LEGACY_VIEW_STORAGE_KEY = "userView";

export const ALLOWED_VIEWS = new Set([
  "customer",
  "professional",
  "admin",
  "recruiter",
]);

const canUseStorage = () =>
  typeof window !== "undefined" && Boolean(window.localStorage);

const isValidView = (view) => ALLOWED_VIEWS.has(view);

const safeGetItem = (key) => {
  try {
    return window.localStorage.getItem(key);
  } catch (error) {
    return null;
  }
};

const safeSetItem = (key, value) => {
  try {
    window.localStorage.setItem(key, value);
  } catch (error) {
    // Ignore storage failures so view context can still work in-memory.
  }
};

const safeRemoveItem = (key) => {
  try {
    window.localStorage.removeItem(key);
  } catch (error) {
    // Ignore storage failures so view context can still work in-memory.
  }
};

export const migrateLegacyViewIfNeeded = () => {
  if (!canUseStorage()) {
    return null;
  }

  const currentView = safeGetItem(CURRENT_VIEW_STORAGE_KEY);
  if (isValidView(currentView)) {
    return currentView;
  }

  const legacyView = safeGetItem(LEGACY_VIEW_STORAGE_KEY);
  if (isValidView(legacyView)) {
    safeSetItem(CURRENT_VIEW_STORAGE_KEY, legacyView);
    safeRemoveItem(LEGACY_VIEW_STORAGE_KEY);
    return legacyView;
  }

  return null;
};

export const readPersistedView = () => {
  if (!canUseStorage()) {
    return null;
  }

  const currentView = safeGetItem(CURRENT_VIEW_STORAGE_KEY);
  if (isValidView(currentView)) {
    return currentView;
  }

  return migrateLegacyViewIfNeeded();
};

export const persistView = (view) => {
  if (!canUseStorage()) {
    return;
  }

  if (!isValidView(view)) {
    safeRemoveItem(CURRENT_VIEW_STORAGE_KEY);
    return;
  }

  safeSetItem(CURRENT_VIEW_STORAGE_KEY, view);
};

export const clearPersistedView = () => {
  if (!canUseStorage()) {
    return;
  }

  safeRemoveItem(CURRENT_VIEW_STORAGE_KEY);
  // Legacy compatibility cleanup for users who still have stale keys.
  safeRemoveItem(LEGACY_VIEW_STORAGE_KEY);
};
